export default class PhotosClient {
    constructor(apiClient) {
        this.apiClient = apiClient;
        this.getCountryPhotos = this.getCountryPhotos.bind(this);
        this.getCountryPhotosGeneric = this.getCountryPhotosGeneric.bind(this);
        this.getCountryEmailPhotos = this.getCountryEmailPhotos.bind(this);
        this.getCountryEmailPhotosGeneric = this.getCountryEmailPhotosGeneric.bind(this);
        this.postPhotoSearch = this.postPhotoSearch.bind(this);
        this.getPhoto = this.getPhoto.bind(this);
    }
    // ?countries=IT, ?countries=IT,FR,DE (comma separated list of ISOCode2) No countries returns all
    getCountryPhotos(config) {
        return this.apiClient.getPhotos('/country_photos', config);
    }
    getCountryPhotosGeneric(config) {
        return this.apiClient.getPhotos('/country_photos/generic', config);
    }
    getCountryEmailPhotos(config) {
        return this.apiClient.getPhotos('/country_email_photos', config);
    }
    getCountryEmailPhotosGeneric(config) {
        return this.apiClient.getPhotos('/country_email_photos/generic', config);
    }
    postPhotoSearch(data, config) {
        return this.apiClient.postPhotos('/photos/search', data, config);
    }
    getPhoto(id, config) {
        return this.apiClient.getPhotos(`/photos/${id}`, config);
    }
}
